import { type QueryClient } from "@tanstack/react-query";

import { requireMe } from "udzs-common/auth";

import { skAuthClient, skMeApi } from "./client";

export function requireSkMe(request: Request, queryClient: QueryClient) {
  return requireMe({
    request,
    authClient: skAuthClient,
    queryClient,
    meApi: skMeApi,
  });
}
